var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-group', {
    staticClass: "dimensions-input",
    attrs: {
      "label": _vm.label,
      "errors": _vm.internalErrors
    },
    on: {
      "focus": _vm.focus
    }
  }, [_c('div', {
    staticClass: "uk-grid-small",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-small"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.internalValue.width),
      expression: "internalValue.width",
      modifiers: {
        "number": true
      }
    }],
    ref: "primaryInput",
    staticClass: "uk-input dimensions-input__width",
    class: _vm.inputCss,
    attrs: {
      "type": "number",
      "step": "any",
      "min": "0",
      "disabled": _vm.disabled,
      "placeholder": _vm.$t('fields.width')
    },
    domProps: {
      "value": (_vm.internalValue.width)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.internalValue.width = _vm._n($event.target.value)
      }, _vm.onInput],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dimensions-input__input-separator"
  }, [_vm._v("\n      ×\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-small"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.internalValue.height),
      expression: "internalValue.height",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "uk-input dimensions-input__height",
    class: _vm.inputCss,
    attrs: {
      "type": "number",
      "step": "any",
      "min": "0",
      "disabled": _vm.disabled,
      "placeholder": _vm.$t('fields.height')
    },
    domProps: {
      "value": (_vm.internalValue.height)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.internalValue.height = _vm._n($event.target.value)
      }, _vm.onInput],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dimensions-input__input-separator"
  }, [_vm._v("\n      ×\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-small"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.internalValue.depth),
      expression: "internalValue.depth",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "uk-input dimensions-input__depth",
    class: _vm.inputCss,
    attrs: {
      "type": "number",
      "step": "any",
      "min": "0",
      "disabled": _vm.disabled,
      "placeholder": _vm.$t('fields.depth')
    },
    domProps: {
      "value": (_vm.internalValue.depth)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.internalValue.depth = _vm._n($event.target.value)
      }, _vm.onInput],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalValue.unit),
      expression: "internalValue.unit"
    }],
    staticClass: "uk-select dimensions-input__unit",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.internalValue.unit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onInput]
    }
  }, _vm._l((_vm.availableUnits), function(unit) {
    return _c('option', {
      domProps: {
        "value": unit
      }
    }, [_vm._v("\n          " + _vm._s(_vm.translateUnit(unit)) + "\n        ")])
  }))])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-586d2152","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/DimensionsInput.vue
// module id = 1996
// module chunks = 0